import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import RisksPage from './pages/Risks.jsx';

function App() {
  return (
    <Router>
      <div className="min-h-screen">
        <main className="h-full">
          <Routes>
            <Route path="/risks" element={<RisksPage />} />
            <Route path="/" element={<RisksPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
